import React from 'react'

export const SectionC = () => {
    return (
        <>
            <section className="section-3">
                <h1><b>02.</b> WORK</h1>
                <div className="pjimg">
                    <h2>1 traveling blog website</h2>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi iure nihil atque ab eum reiciendis
                        dignissimos culpa mollitia nisi, asperiores ea, voluptatibus pariatur explicabo perferendis
                        exercitationem velit quaerat sed cupiditate.
                    </p>
                    <div className="borderpj" id="borderpj1"><img className="pj1" src={process.env.PUBLIC_URL + "/pj1.png"} alt="error" /></div>
                </div>
                <div className="pjimg">
                    <h2>2 website on yacht trip</h2>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi iure nihil atque ab eum reiciendis
                        dignissimos culpa mollitia nisi, asperiores ea, voluptatibus pariatur explicabo perferendis
                        exercitationem velit quaerat sed cupiditate.
                    </p>
                    <div className="borderpj" id="borderpj2"><img className="pj2" src={process.env.PUBLIC_URL + "/pj2.png"} alt="error" /></div>
                </div>
                <div className="pjimg">
                    <h2>3 web of a restaurant</h2>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi iure nihil atque ab eum reiciendis
                        dignissimos culpa mollitia nisi, asperiores ea, voluptatibus pariatur explicabo perferendis
                        exercitationem velit quaerat sed cupiditate.
                    </p>
                    <div className="borderpj" id="borderpj3"><img className="pj3" src={process.env.PUBLIC_URL + "/pj3.png"} alt="error" /></div>
                </div>
            </section>
        </>
    )
}
